<template>
  <div v-show="!errorCheck" class="group-detail">
    <h1 class="common__main-title">Preparation Result</h1>
    <div v-if="lesson" class="common__sub-title justify-content-center">
      {{ lesson.fiscalYear }} {{ lesson.semester.name }} {{ lesson.course.name }}
      {{ lesson.date | weekday }} Period{{ lesson.period }} Unit{{ lesson.unit }}
      {{ lesson.campus.name }}
      {{ lesson.booth.building }}-{{ lesson.booth.room }}-{{ lesson.booth.number }}
    </div>

    <div v-if="preparation" class="student-list">
      <div
        v-for="{ student } of preparation.students"
        :key="student.id"
        class="w-25 p-1"
      >
        <button class="student-button" @click="selectedStudent = student">
          {{ student.name }}
        </button>
      </div>
    </div>

    <div v-if="quizzes">
      <div
        v-for="{ question, position, answers } of quizzes"
        :key="position"
        class="preparation"
      >
        <h6 class="mb-3 d-flex">
          <p class="mr-2">{{ position }}.</p>
          <div v-html="question"></div>
        </h6>
        <div
          class="ml-3 mb-3"
          v-for="answer of answers"
          :key="answer.choice"
        >
          <div class="d-flex align-items-center">
            <div :class="{ 'text-danger': answer.isCorrect }" class="mr-4">
              {{ answer.choice }}
            </div>
            <div class="answerStudent" v-if="answer.isSelected">
              {{ selectedStudent.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <b-button pill variant="secondary" @click="$router.go(-1)">
        Back
      </b-button>
    </div>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import Loading from '@/components/parts/modal/Loading.vue'
import { Preparation, Quiz } from '@/store/lessons/preparation/types'
import { Student } from '@/store/students/types'
import { Lesson } from '@/store/lessons/types'
import { Moment } from 'moment'

export default Vue.extend({
  components: {
    Loading,
  },
  filters: {
    weekday: (date: Moment) => date.format('ddd'),
  },

  data: (): {
    isLoading: boolean,
    selectedStudent: Student|undefined,
    } => ({
    isLoading: false,
    selectedStudent: undefined,
  }),

  created() {
    this.isLoading = true
    this.$store.dispatch('getPreparation', this.$route.params.lessonId)
    this.$store.dispatch('getLessonByScheduleId', { scheduleId: this.$route.params.lessonId })
      .finally(() => {
        this.isLoading = false
        this.selectedStudent = _.first(this.preparation?.students)?.student
        if (this.errorCheck) {
          this.$router.push({ name: 'OldLMSData' })
        }
      })
  },

  computed: {
    lesson(): Lesson|null {
      return this.$store.getters.findLessonByScheduleId(this.$route.params.lessonId)
    },
    preparation(): Preparation|null {
      return this.$store.getters.findPreparationByLessonId(this.$route.params.lessonId)
    },
    quizzes(): Quiz[] {
      return _.chain(this.preparation)
        .get('students')
        .find((s) => s.student.id === this.selectedStudent?.id)
        .get('quizzes')
        .value() || []
    },
    errorCheck(): boolean {
      if (this.lesson && this.lesson.fiscalYear <= 2023) {
        return true
      }
      return false
    },
  },
})
</script>

<style scoped>
.student-list{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.student-button{
  padding: 15px;
  width: 100%;
  text-align: center;
  background-color: #E7E6E6;
  border-style: none;
  cursor: pointer;
}

.student-button:hover{
  background-color: #B0C4DE;
}

.preparation {
  background: #DDEAF6;
  padding: 20px;
  margin-bottom: 30px;
  position: relative;
}

.answerStudent {
  padding: 5px 20px;
  background: #E7E6E6;
}
</style>
